<app-selection-modal
  title="Select a Contact type"
  [selectionItems]="items"
  (close)="closeModal()">
</app-selection-modal>
